import { z } from "zod";

import { FINDING_CATEGORIES } from "./FINDING_CATEGORIES";

// Search params экрана разбора: `/matches/1?section=deaths`. Нет параметра — открыта
// самая проблемная категория (`defaultSection`), `none` — все секции свёрнуты.
// Неверное значение просто пропадает.
export const analysisSearchSchema = z.object({
  section: z
    .enum(["none", ...FINDING_CATEGORIES])
    .optional()
    .catch(undefined),
});

export type AnalysisSearch = z.infer<typeof analysisSearchSchema>;
